import config from '@project/config';

const aboutUsDetailsBaseUrl = `${config.apiUrl}/about_us_details/1`;

export default {
  aboutUsDetailsUrl: () => aboutUsDetailsBaseUrl,
};
